import { EmailVehicleVisualsCtrl }   from './vehicle-visuals.email';
import { ModalDialogController }     from './vehicle-visuals.modal-dialog-controller';
import { VehicleVisuals }            from './vehicle-visuals.service';
import { VehicleVisualsCatalog }     from './vehicle-visuals.catalog.directive';
import { VehicleVisualsCatalogCtrl } from './vehicle-visuals.catalog';
import { VehicleVisualsCtrl }        from './vehicle-visuals';
import { VehicleVisualsModalCtrl }   from './vehicle-visuals.modal';
import { VehicleVisualsStates }      from './vehicle-visuals.states.ajs';

angular.module('workshop.vehicle-visuals', [])

.controller('EmailVehicleVisualsCtrl',   EmailVehicleVisualsCtrl)
.controller('ModalDialogController',     ModalDialogController)
.controller('VehicleVisualsCatalogCtrl', VehicleVisualsCatalogCtrl)
.controller('VehicleVisualsCtrl',        VehicleVisualsCtrl)
.controller('VehicleVisualsModalCtrl',   VehicleVisualsModalCtrl)

.directive('vehicleVisualsCatalog',      VehicleVisualsCatalog)

.factory('VehicleVisuals',               VehicleVisuals)

.config(VehicleVisualsStates);
